// src/components/ads/FooterAd.js
import AdSlot from "../AdSlot";

export default function FooterAd() {
  return (
    <AdSlot
      slot="2729446592"
      className="mt-4 mb-2"
      style={{ minHeight: "90px" }}
    />
  );
}